import { render, staticRenderFns } from "./buySuccess.vue?vue&type=template&id=752e0fcc&scoped=true"
import script from "./buySuccess.vue?vue&type=script&lang=js"
export * from "./buySuccess.vue?vue&type=script&lang=js"
import style0 from "./buySuccess.vue?vue&type=style&index=0&id=752e0fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e0fcc",
  null
  
)

export default component.exports